import AnimationFadeIn from "@components/AnimationFadeIn";
import dayjs from "dayjs";
import ModalCst, { OutcomesInterface } from "@components/ModalCst";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { Box } from "@mui/material";
import { ServicesURL, getAllErrorsAsString, uploadFile } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useMemo, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ContextProjectFormCst from "./ContextProjectFormCst";
import { MethodType } from "src/services/type";
import { useAuth } from "@context/auth";

type ContextProjectProps = {
  projectStatus?: string;
};

const ContextProject: React.FC<ContextProjectProps> = ({
  projectStatus = "",
}) => {
  const { t } = useTranslation(["projects-context-page"]);
  const { idProject, id } = useParams();
  const navigate = useNavigate();
  const [forceUpdate, setForceUpdate] = useState(0);
  const { user } = useAuth();

  /*########### ROLE PERMISSION ###########*/

  /*Permission to indetify PM*/
  const isPM = user?.permissions.find(
    (permission: any) =>
      permission === "usermgmt.budget.project.mark.as.pending.activation",
  );

  /*#######################################*/

  const { columns, dataDetail, mutate } = useFetchDataDetail(
    `${ServicesURL.getProjectsContext}/${idProject}?corporateId=${id}`,
    PagesID["projects.context"],
  );

  const initialOutcome: OutcomesInterface = {
    budget: {
      code: undefined,
      message: t("edit.outcome.project.messageLoading"),
      title: t("edit.outcome.project.title"),
    },
  };

  const [outcome, setOutcome] = useState<OutcomesInterface>(initialOutcome);
  const [openOutcome, setOpenOutcome] = useState(false);

  const onSubmit = async (inputForm: any) => {
    setOpenOutcome(true);
    const newOutcome = JSON.parse(JSON.stringify(initialOutcome));

    const formData = new FormData();
    formData.append("context", inputForm.context || "");
    formData.append("description", inputForm.description || "");
    formData.append("objectives", inputForm.objectives || "");
    formData.append(
      "actualStartDate",
      inputForm.actual_start_date
        ? dayjs(inputForm.actual_start_date).format("YYYY-MM-DD")
        : "",
    );
    formData.append(
      "actualEndDate",
      inputForm.actual_end_date
        ? dayjs(inputForm.actual_end_date).format("YYYY-MM-DD")
        : "",
    );

    //Gestione file (se presenti)
    if (inputForm.files && inputForm.files.length > 0) {
      Array.from(inputForm.files).forEach((file: any) => {
        if (file.file) {
          formData.append("file", file.file);
        }
      });
    }

    try {
      if (dataDetail?.[0]) {
        await uploadFile(
          `${ServicesURL.postProjectsContext}/${idProject}/${inputForm.id}`,
          formData,
          MethodType.PUT,
        );
      } else {
        await uploadFile(
          `${ServicesURL.postProjectsContext}/${idProject}`,
          formData,
          MethodType.POST,
        );
      }
      newOutcome.budget.code = "OK";
      newOutcome.budget.message = t("edit.outcome.project.messageOK");
      setOutcome(newOutcome);
    } catch (error: any) {
      newOutcome.budget.code = "KO";
      newOutcome.budget.message = getAllErrorsAsString(error);
      setOutcome(newOutcome);
    }

    mutate(inputForm);
  };

  const getColumns = useMemo(() => {
    return columns;
  }, [columns]);

  return (
    <AnimationFadeIn key={forceUpdate}>
      {getColumns && (
        <Box>
          <ContextProjectFormCst
            row={dataDetail?.[0] || []}
            columns={getColumns}
            onSubmit={onSubmit}
            backButton={() => navigate(-1)}
            fullWidth={true}
            readOnly={!!(isPM && projectStatus === "CLOSED")}
            mutate={mutate}
          />
        </Box>
      )}
      <ModalCst
        open={openOutcome}
        setOpen={setOpenOutcome}
        typeOfModal={"outcome"}
        data={{
          outcome: outcome,
          callBackSubmit: () => {
            setOpenOutcome(false);
            setForceUpdate((prev) => prev + 1);
            setOutcome(initialOutcome);
          },
        }}
      />
    </AnimationFadeIn>
  );
};

export default ContextProject;
